module.exports = __webpack_public_path__ + "img/identificationActiveOk.042eca40.svg";